import React, { useMemo } from 'react';
import FlightsResults from './components/FlightsResults';
import { TEST_ID_FLIGHTS_RESULTS } from '../constants';
import FlightsSkeleton from '../../../../components/Flights/FlightsSkeleton';
import type { PropsFromRedux } from '.';

const FlightsLoadingResults = (props: PropsFromRedux): JSX.Element => {
  const { isLoading, id, isMobile, visibleFlightsCount } = props;
  const skeletonArray = useMemo(
    () =>
      Array.from(
        {
          length: visibleFlightsCount,
        },
        (_, index) => index + 1,
      ),
    [visibleFlightsCount],
  );
  return (
    <div id={id}>
      {!isLoading ? (
        <FlightsResults data-testid={TEST_ID_FLIGHTS_RESULTS} />
      ) : (
        <>
          {isMobile && <FlightsSkeleton />}
          {!isMobile && (
            <>
              {skeletonArray.map((key) => (
                <FlightsSkeleton key={key} />
              ))}
            </>
          )}
        </>
      )}
    </div>
  );
};

export default FlightsLoadingResults;
